export default {
    ui: {
        helpAria: "Abrir tutorial de esta sección",
        slideOf: "Diapositiva {{current}} de {{total}}",
        getStarted: "Empezar",
        dialogIntro: "Introducción a esta área",
        goToSlide: "Ir a la diapositiva {{n}} de {{total}}",
    },
    shipper: {
        askEve: {
            label: "Ask Eve",
            mockUi: {
                eveName: "Eve",
                assistantSubtitle: "Asistente de IA",
                typingStatus: "Escribiendo",
                yourMessage: "Tú",
                eveReply: "Eve",
                composeTitle: "Escribe tu mensaje",
                placeholder: "Haz una pregunta…",
                send: "Enviar",
            },
            slides: [
                {
                    title: "Bienvenido a Ask Eve",
                    body: "Tu asistente de IA para envíos, documentos y próximos pasos. Haz preguntas en lenguaje natural y obtén respuestas alineadas con tu espacio de trabajo.",
                    mock: "eve-chat-intro",
                },
                {
                    title: "Ayuda con contexto",
                    body: "Eve puede sugerir acciones, resumir el estado y señalar riesgos usando los mismos datos que ves en EveMind, sin saltar entre páginas.",
                    mock: "eve-context-cards",
                },
                {
                    title: "Sigue la conversación",
                    body: "Continúa en el mismo hilo para afinar una petición, añadir detalles o explorar otro enfoque sobre el mismo tema.",
                    mock: "eve-thread",
                },
                {
                    title: "Tú tienes el control",
                    body: "Cuando quieras, cierra este recorrido y escribe tu primera pregunta en el chat. Puedes volver a abrir esta guía con el botón de ayuda.",
                    mock: "eve-compose",
                },
            ],
        },
        controlHub: {
            label: "Control Hub",
            slides: [
                {
                    title: "Tu Control Hub",
                    body: "Un solo lugar para ver cómo va tu operación y en qué centrarte hoy, antes de entrar en cada módulo.",
                    mock: "hub-hero-cards",
                },
                {
                    title: "Prioridades de un vistazo",
                    body: "Métricas y señales clave te ayudan a detectar retrasos, riesgo y carga de trabajo sin abrir todas las áreas de la aplicación.",
                    mock: "hub-kpis",
                },
                {
                    title: "Del insight a la acción",
                    body: "Usa el hub para pasar a operaciones, coordinación o flujos comerciales con el contexto que necesitas para decidir rápido.",
                    mock: "hub-shortcuts",
                },
                {
                    title: "Listo para explorar",
                    body: "Cierra esta introducción y recorre el hub. Este tour no volverá a mostrarse salvo que lo abras desde el botón de ayuda.",
                    mock: "hub-ready",
                },
            ],
        },
        operations: {
            label: "Operaciones",
            slides: [
                {
                    title: "Espacio de operaciones",
                    body: "Gestiona contenedores, sigue el seguimiento en vivo y mantén los documentos organizados: tu área operativa diaria como cargador.",
                    mock: "ops-modules",
                },
                {
                    title: "Contenedores y seguimiento",
                    body: "Supervisa hitos, rutas y actualizaciones de estado para saber qué se mueve, qué va retrasado y qué requiere atención.",
                    mock: "ops-route",
                },
                {
                    title: "Documentos en un solo sitio",
                    body: "Sube, clasifica y encuentra documentos de envío vinculados a tus embarques para validaciones y entregas más ágiles.",
                    mock: "ops-files",
                },
                {
                    title: "Adéntrate",
                    body: "Elige Contenedores, Seguimiento en vivo o Documentos en la barra lateral. Puedes repetir este tour desde el botón de ayuda.",
                    mock: "ops-nav-hint",
                },
            ],
        },
        coordination: {
            label: "Coordinación",
            slides: [
                {
                    title: "Mantente coordinado",
                    body: "Actividad, incidencias y centro de revisión trabajan juntos: el equipo ve qué cambió, qué falla y qué sigue pendiente de decisión humana.",
                    mock: "coord-pillars",
                },
                {
                    title: "Feed de actividad",
                    body: "Sigue un flujo cronológico de avisos y actualizaciones de tus envíos para que lo importante no quede enterrado en el correo.",
                    mock: "coord-feed",
                },
                {
                    title: "Incidencias y revisión",
                    body: "Controla problemas abiertos y revisiones pendientes: resuelve bloqueos y aprobaciones antes de que generen retrasos o coste extra.",
                    mock: "coord-tickets",
                },
                {
                    title: "Mantén el control",
                    body: "Visita estas áreas con frecuencia para desbloquear a tiempo. Cierra el tour cuando quieras empezar desde la barra lateral.",
                    mock: "coord-rhythm",
                },
            ],
        },
        commercial: {
            label: "Comercial",
            slides: [
                {
                    title: "Flujos comerciales",
                    body: "Gestiona pedidos y cotizaciones de flete en una macroárea alineada con cómo compras, vendes y mueves la carga.",
                    mock: "comm-bridge",
                },
                {
                    title: "Pedidos",
                    body: "Crea y supervisa pedidos ligados a tu pipeline logística para que la intención comercial siga ligada a la ejecución.",
                    mock: "comm-order-card",
                },
                {
                    title: "Cotizaciones",
                    body: "Solicita y compara cotizaciones de transporte para equilibrar precio, nivel de servicio y plazos en cada envío.",
                    mock: "comm-quote-compare",
                },
                {
                    title: "Cierra el ciclo",
                    body: "Pasa de decisiones comerciales a operaciones sin perder contexto. Cierra el tour para seguir en Pedidos o Cotizaciones.",
                    mock: "comm-handoff",
                },
            ],
        },
        network: {
            label: "Red",
            slides: [
                {
                    title: "Tu red",
                    body: "Socios, equipo y contactos son la base de un shipping fiable: aquí los mantienes ordenados.",
                    mock: "net-graph",
                },
                {
                    title: "Socios comerciales",
                    body: "Cuida las relaciones con transitarios, navieras y contrapartes con las que trabajas para que cada envío apunte a la parte correcta.",
                    mock: "net-partner-cards",
                },
                {
                    title: "Equipo y accesos",
                    body: "Invita a compañeros y gestiona quién puede ver o actuar sobre los datos de la empresa: esencial para colaborar con seguridad.",
                    mock: "net-team-row",
                },
                {
                    title: "Agenda de direcciones",
                    body: "Centraliza contactos y ubicaciones para que formularios y documentos se mantengan coherentes. Cierra el tour cuando quieras explorar.",
                    mock: "net-contact-card",
                },
            ],
        },
    },
};
